import React from 'react';
import { HardHat } from 'lucide-react';

/**
 * Modal reutilizable para secciones en construcción
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.isOpen - Controla si el modal está visible
 * @param {function} props.onClose - Función a llamar cuando el modal se cierra
 * @param {string} props.title - Título del modal (por defecto: "¡En Construcción!")
 * @param {string} props.message - Mensaje principal (por defecto: mensaje estándar)
 * @param {string} props.buttonText - Texto del botón (por defecto: "Entendido")
 * @param {function} props.onButtonClick - Función adicional al hacer clic en el botón
 */
const ConstructionModal = ({
  isOpen,
  onClose,
  title = "¡En Construcción!",
  message = "Estamos trabajando para implementar esta funcionalidad. ¡Muy pronto disponible!",
  buttonText = "Entendido",
  onButtonClick
}) => {
  if (!isOpen) return null;

  const handleButtonClick = () => {
    onClose();
    if (onButtonClick) onButtonClick();
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-sm w-full text-center"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-center mb-4">
          <HardHat className="w-16 h-16 text-yellow-500" />
        </div>
        <h2 className="text-2xl font-bold mb-2 dark:text-white">{title}</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          {message}
        </p>
        <button
          onClick={handleButtonClick}
          className="w-full px-4 py-3 bg-yellow-500 hover:bg-yellow-600 text-white rounded-xl font-medium transition-colors"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default ConstructionModal; 